import { render, staticRenderFns } from "./PayableReceivableTotalization.vue?vue&type=template&id=3facbb72&scoped=true&"
import script from "./PayableReceivableTotalization.vue?vue&type=script&lang=js&"
export * from "./PayableReceivableTotalization.vue?vue&type=script&lang=js&"
import style0 from "./PayableReceivableTotalization.vue?vue&type=style&index=0&id=3facbb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3facbb72",
  null
  
)

export default component.exports